import TablePages from './TablePages';

export default (props) => {
  return <TablePages {...props} />;
};
